import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Button from 'components/common/Button'
import theme from 'theme'
import { messageFromResponseError } from 'utils/strings'

import ErrorMessage from './ErrorMessage'

export default function ContentErrorMessage({
  fetchError,
  destination,
  returnText,
  type = 'attack',
  ...rest
}) {
  return (
    <ErrorMessage>
      <div {...rest}>
        {messageFromResponseError(
          fetchError,
          `There was an error fetching the ${type}.`
        )}
      </div>
      <Button
        as={Link}
        css={{ marginTop: theme.space[3] }}
        label={returnText}
        to={destination}
      />
    </ErrorMessage>
  )
}

ContentErrorMessage.propTypes = {
  destination: PropTypes.string,
  fetchError: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  returnText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  type: PropTypes.oneOf(['attack', 'scenario'])
}
